import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import useTranslation from 'next-translate/useTranslation';

// Context
import ApproachContext from '../../../../../context/ApproachContext';

// PropTypes
import { companyPropTypes } from '../../../../../proptypes/companyProptypes';

// Icons
import { ThumbsUp } from '../../../../icons';

// Styles
import styles from '../jobBulletpoints.module.scss';

const JobDiversity = ({ company, textColor }) => {
  const approach = useContext(ApproachContext);
  const { t } = useTranslation('common');

  if (!company.diversity_toggle) return null;

  return (
    <div className={styles.container}>
      <span className={styles.content}>
        <span className={styles.iconWrapper}>
          <ThumbsUp fill={textColor} className={styles.icon} />
        </span>

        <span className={styles.text}>
          {t(`description_page.main_section.equal_opportunity.${approach}`)}
        </span>
      </span>
    </div>
  );
};

JobDiversity.propTypes = {
  company: PropTypes.shape(companyPropTypes).isRequired,
  textColor: PropTypes.string.isRequired,
};

export default JobDiversity;
